module.exports = __webpack_public_path__ + "img/sstz_bg2.039a0984.png";